import { render, staticRenderFns } from "./WorkInProgress.vue?vue&type=template&id=17dcf408&"
import script from "./WorkInProgress.vue?vue&type=script&lang=js&"
export * from "./WorkInProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports